import React, { useState, useEffect } from "react";
import axios from "axios";
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import { useNavigate } from 'react-router-dom';

const AddPurchase = () => {
    const navigate = useNavigate();

    const [venders, setVenders] = useState([]);
    const [items, setItems] = useState([]);
    const [formData, setFormData] = useState({
        vender: '',
        item: '',
        quantity: '',
        price: '',
        totalAmount: '',
        gst: '',
        grandTotal: '',
        PaymentMode: 'Cash',
        remark: '',
        invoiceNo: ''
    });

    // Fetch venders
    // const getVenders = async () => {
    //     try {
    //         const response = await axios.get('http://localhost/projects/api.trucoo.in/vender/all-vender/', {
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'X-API-KEY': 'erpTrucoo'
    //             }
    //         });
    //         setVenders(response.data);
    //     } catch (error) {
    //         console.error("Error fetching venders:", error);
    //     }
    // };

    // Fetch items
    // const getItems = async () => {
    //     try {
    //         const response = await axios.get('http://localhost/projects/api.trucoo.in/item/all-item/', {
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'X-API-KEY': 'erpTrucoo'
    //             }
    //         });
    //         setItems(response.data);
    //     } catch (error) {
    //         console.error("Error fetching items:", error);
    //     }
    // };

    // useEffect(() => {
    //     getVenders();
    //     getItems();
    // }, []);

    // Handle changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => {
            const newData = { ...prev, [name]: value };
            
            // Calculate totals when quantity or price changes
            if (name === 'quantity' || name === 'price') {
                const quantity = parseFloat(newData.quantity) || 0;
                const price = parseFloat(newData.price) || 0;
                const total = quantity * price;
                const gst = total * 0.18; // Assuming 18% GST
                
                return {
                    ...newData,
                    totalAmount: total.toFixed(2),
                    gst: gst.toFixed(2),
                    grandTotal: (total + gst).toFixed(2)
                };
            }
            
            return newData;
        });
    };

    // Submit
    const handleSubmit = (e) => {
        e.preventDefault();

        console.log("Form Submitted: ", formData);

        axios.post('http://localhost/projects/api.trucoo.in/purchase/add-purchase/', formData, {
            headers: {
                'Content-Type': 'application/json',
                'X-API-KEY': 'erpTrucoo'
            }
        })
            .then(response => {
                if (response.data.status === "success") {
                    
                } else {
                    console.error(response.data);
                }
            })
            .catch(error => {
                console.error("There was an error submitting:", error);
            });
    };

    return (
        <>
            <Header />
            <Sidebar />

            <div className="content-wrapper">
                <div className="container-full">
                    <section className="content">
                        <div className="box box-body">
                            <div className="row">
                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                                    <div className="box">
                                        <div className="box-body">
                                            <h4 className="box-title text-primary mb-0"><i className="ti-user me-15"></i>Payment Made</h4>
                                            <hr className="my-15" />
                                            <div className="row">

                                                {/* Vender */}
                                                {/* <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form-label">Vender</label>
                                                        <select 
                                                            className="form-control" 
                                                            name="vender"
                                                            value={formData.vender}
                                                            onChange={handleChange}
                                                            required
                                                        >
                                                            <option value="">Select Vender</option>
                                                            {venders.map((vender) => (
                                                                <option key={vender.id} value={vender.id}>{vender.name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div> */}

                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form-label">Vender</label>
                                                         <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Vender Name"
                                                            name="vender"
                                                            value={formData.vender}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                {/* Item */}
                                                {/* <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form-label">Item</label>
                                                        <select 
                                                            className="form-control" 
                                                            name="item"
                                                            value={formData.item}
                                                            onChange={handleChange}
                                                            required
                                                        >
                                                            <option value="">Select Item</option>
                                                            {items.map((item) => (
                                                                <option key={item.id} value={item.id}>{item.name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div> */}

                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form-label">Item</label>
                                                         <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Item Name"
                                                            name="item"
                                                            value={formData.item}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                {/* Quantity */}
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form-label">Quantity</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            placeholder="Enter Quantity"
                                                            name="quantity"
                                                            value={formData.quantity}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                {/* Price */}
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form-label">Price</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            placeholder="Enter Price"
                                                            name="price"
                                                            value={formData.price}
                                                            onChange={handleChange}
                                                            step="0.01"
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                {/* Total Amount (readonly) */}
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form-label">Total Amount</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="totalAmount"
                                                            value={formData.totalAmount}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>

                                                {/* GST (readonly) */}
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form-label">GST (18%)</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="gst"
                                                            value={formData.gst}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>

                                                {/* Grand Total (readonly) */}
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form-label">Grand Total</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="grandTotal"
                                                            value={formData.grandTotal}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>

                                                {/* Invoice No */}
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form-label">Invoice No</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Invoice Number"
                                                            name="invoiceNo"
                                                            value={formData.invoiceNo}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                {/* Payment Mode */}
                                                <div className="col-md-6">
                                                    <div className="form-group mb-0">
                                                        <label className="form-label d-block">Payment Mode</label>
                                                        <div className="d-flex flex-row">
                                                            <div className="form-check me-3">
                                                                <input
                                                                    type="radio"
                                                                    id="radio_1"
                                                                    name="PaymentMode"
                                                                    value="Cash"
                                                                    checked={formData.PaymentMode === "Cash"}
                                                                    onChange={handleChange}
                                                                />
                                                                <label htmlFor="radio_1" className="ms-1">Cash</label>
                                                            </div>
                                                            <div className="form-check me-3">
                                                                <input
                                                                    type="radio"
                                                                    id="radio_2"
                                                                    name="PaymentMode"
                                                                    value="Bank"
                                                                    checked={formData.PaymentMode === "Bank"}
                                                                    onChange={handleChange}
                                                                />
                                                                <label htmlFor="radio_2" className="ms-1">Bank</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Remark */}
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form-label">Remark</label>
                                                        <textarea
                                                            className="form-control"
                                                            placeholder="Enter Remark"
                                                            name="remark"
                                                            value={formData.remark}
                                                            onChange={handleChange}
                                                            rows="1"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="box-footer mt-20" align="center">
                                                <button type="button" className="btn btn-primary-light me-1" onClick={() => navigate('/PaymentMade')}>
                                                    <i className="ti-trash"></i> Cancel
                                                </button>
                                                <button type="submit" className="btn btn-primary" onClick={handleSubmit}>
                                                    <i className="ti-save-alt"></i> Save
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    )
};

export default AddPurchase;